import axios from "axios";

class Resource {

    constructor(module) {
        this.url = `${process.env.REACT_APP_API_BASE_TEST}/${module}`;
        this.module = module;
    }

    index = (params) => {
        return axios.get(this.url, {params});
    };

    show = (id, params = {}) => {
        return axios.get(`${this.url}/${id}`, {params});
    };

    create = (resource) => {
        return axios.post(this.url, resource);
    };

    update = (resource, id) => {
        return axios.patch(`${this.url}/${id ? id : resource.id}`, resource);
    };

    destroy = (resource) => {
        return axios.delete(`${this.url}/${resource.id}`);
    };

    search = (params, part = null) => {
        const url = `${process.env.REACT_APP_API_BASE_TEST}/search/${this.module}${part ? `/${part}` : ''}`
        return axios.get(url, {params});
    };

}

export default Resource;






